import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  freeText: {
    backgroundColor: theme.palette.yellow,
    padding: '2.5rem 0'
  },
  title: {
    fontFamily: 'Veneer, Arial',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '3.8rem',
    color: theme.palette.purple,
    margin: '0 0 1rem',
    textAlign: "center",
    height: "auto"
  },
  paragraphsContainer: {
    margin: "0 auto",
    width: "100%",
    maxWidth: "25.375rem",
    padding: '0 1.25rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: "44rem"
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: "49.25rem"
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "53.5rem"
    }
  },
  paragraph: {
    textAlign: "center",
    color: theme.palette.black,
    height: "auto",
    display: 'inline-block',

    [theme.breakpoints.up('md')]: {
      textAlign: "left",
    }
  },
  paragraphSecondColumn: {
    [theme.breakpoints.up('md')]: {
      marginTop: '2rem',
      marginLeft: '1.5625rem'
    }
  },
  ctasContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: '2rem'
  },
  white: {
    color: theme.palette.white
  },
  yellow: {
    color: theme.palette.yellow
  },
  purple: {
    color: theme.palette.purple
  },
  black: {
    color: theme.palette.black
  },
  center: {
    textAlign: "center"
  },
  left: {
    textAlign: "left"
  }
}));
